export { default } from './stopDefault'
